<template>
<div>
<v-form
   ref="form"
   v-model="valid"
   @submit.prevent="submit"
>
<v-container fluid class="mb-5">
    <v-row justify="space-between">
      <v-col cols="12" class="text-left">

        <template v-if="true">
        <v-btn color="" class="mr-5" @click="$router.go(-1)">
            戻る</v-btn>
        <v-btn type="submit" color="" class="white--text mygreen">
            保存</v-btn>
      </template>

      </v-col>
    </v-row>
  </v-container>

  <v-card class="pa-4 pb-10 mycard">
    <v-container fluid class="myform">

        <v-row>
            <v-col  cols="3" class="text-left">
                <h3 class="">メールテンプレート登録</h3>
            </v-col>
        </v-row>

        <v-row>
          <v-col cols="2" class="text-left" align-self="center">
              <div>テンプレート名</div>
          </v-col>
          <v-col cols="1" align-self="center">
              <v-chip label outlined color="red">必須</v-chip>
          </v-col>
          <v-col cols="4" class="pt-11">
              <v-text-field
              v-model="data.name"
              color="#8CC11E"
              label="テンプレート名"
              outlined></v-text-field>
          </v-col>
          <v-col cols="5"> </v-col>
        </v-row>

        <v-row>
          <v-col cols="2" class="text-left" align-self="center">
              <div>メールタイトル</div>
          </v-col>
          <v-col cols="1" align-self="center">
              <v-chip label outlined color="red">必須</v-chip>
          </v-col>
          <v-col cols="4" class="pt-11">
              <v-text-field
              v-model="data.title"
              color="#8CC11E"
              label="メールタイトル"
              outlined></v-text-field>
          </v-col>
          <v-col cols="5"> </v-col>
        </v-row>

        <v-row>
          <v-col cols="2" class="text-left pt-11" align-self="start">
              <div>メール文章</div>
          </v-col>
          <v-col cols="1" align-self="start" class="pt-11">
              <v-chip label outlined color="red">必須</v-chip>
          </v-col>
          <v-col cols="6" align-self="end" class="pt-11">
                              <v-textarea
                              label="メール文章"
                              v-model="data.detail"
                              rows="20"
                              outlined></v-textarea>
          </v-col>
        </v-row>

    </v-container>
  </v-card>
</v-form>


<template>
  <div class="text-center">
    <v-snackbar
      v-model="snackbar"
      timeout="3000"
      vertical
      top
      right
      outlined
    >
      <div v-html="snackbar_text"></div>
      <template v-slot:action="{  }">
        <img @click="snackbar = false" class="img" src="/img/x.svg" style="cursor:pointer;" />
      </template>
    </v-snackbar>
  </div>
</template>

</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex';
import DialogPatientSearch from '@/components/DialogPatientSearch.vue';
import DialogMonshinnaiyou from '@/components/DialogMonshinnaiyou.vue';
import DialogSyochinaiyou from '@/components/DialogSyochinaiyou.vue';
/* eslint-disable */


  export default {
    components:{
        DialogPatientSearch, DialogMonshinnaiyou, DialogSyochinaiyou
    },

    computed: {
        ...mapGetters(['user', 'user_name', 'is_admin']),
    },

    // datas
    data(){
        return {
          // for snackbar
          reserve_id: null,
          dialogDelete: false,
          title: '',
          snackbar: false,
          snackbar_text: '登録完了しました',
          valid: false,

          data:{
              name:'',
              title:'',
              detail:'',
          }

        }

    },  // datas

    created () {
        console.log('%ccreated: TemplateDetail.vue', mycolor.created);
        console.log(this.$route);
        this.initialize();
    },

    methods: {

          initialize () {

              axios.get('/get_template_detail/' + this.$route.params.name)
                  .then((res) => {
                    console.group();
                    console.log(`%c/get_template_detail`, mycolor.orange);
                    console.log(res.data);
                    console.groupEnd();
                    this.data = res.data;

                  })
                  .catch((error) => {
                    console.error(error);
                    alert('テンプレートが見つかりませんでした');
                    window.location.href = '/template';
                  });

            },  // initialize()

        submit(){
            console.group();
            console.log('submit()');
            console.log('%cthis.data', mycolor.purple);
            console.log(this.data);
            console.groupEnd();

            axios.post('/update_template', this.data)
              .then((res) => {
                console.log('%c /update_template', mycolor.api);
                console.log(res.data);
                this.snackbar_text = `保存しました`
                this.snackbar = true
                return false;

              })
              .catch(() => {
                  console.error('');
              });

        },  // submit()

    },  // methods

  }


</script>


<style scoped>
.mycard{
  height: 1384px;
}
.myform .row{
  max-height: 100px;
}
/*
.container{
  border: 1px solid green;
}
.row{
  border: 1px solid red;
}
.col{
  border: 1px solid blue;
}
*/
/deep/ .v-input__append-inner{
    margin: 0 !important;
    margin: auto !important;
}
/deep/ fieldset{
    background: #fff;
}
/deep/ .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
    height: 48px;
}
/deep/ .v-text-field.v-textarea:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
    height: unset !important;
}
/deep/ .row + .row{
    margin-top: 0px;
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .v-text-field .v-label{
    line-height: 14px !important;
}
/deep/ .btn_group > div{
    display: inline-block;
    width: 124px;
    margin-right: 18px;
}
/deep/ .btn_group button{
    width: 124px;
}
/deep/ .v-snack--vertical .v-snack__wrapper{
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: space-between !important;
    margin-top: 84px;
    min-width: unset;
    padding: 0 20px;
}
/deep/ .v-snack__content{
    padding: 0px !important;
    margin-right: 30px;
}
/deep/ .v-snack--vertical .v-snack__wrapper .v-snack__action{
    margin: 0 !important;
    align-self: unset !important;
}
/deep/ .v-snack:not(.v-snack--has-background) .v-snack__wrapper{
    border: none !important;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
</style>
